import * as Sentry from "@sentry/react";
import { get } from "lodash";
import { toast } from "react-hot-toast";

import { ROUTE_PATH } from "src/constants";
import { SWR_ACCOUNT_INFO_KEY } from "src/services/swr_keys";
import { SERVICE_1, callLambda } from "src/utils/lambda";
import { getSeriesInfo } from "src/utils/series";

import useAuthSWR from "./useAuthSWR";
import useAppNavigate from "../useAppNavigate";

const getInvitationCodeBySlug = slug => window.localStorage.getItem(slug);

export default () => {
  const appNavigate = useAppNavigate();
  const { slug, invitationCode } = getSeriesInfo();

  return useAuthSWR(SWR_ACCOUNT_INFO_KEY(slug, invitationCode), () => callLambda({
    method                : "get",
    service               : SERVICE_1,
    url                   : "getAccountInfo",
    queryStringParameters : { invitationCode: getInvitationCodeBySlug(slug) },
  }), {
    onError: (error) => {
      const errorMessage = get(error, "response.data.err")
        ?? get(error, "message")
        ?? "Unable to load account info. Please try again.";
      if (errorMessage?.includes("INV-101")) {
        return appNavigate(ROUTE_PATH.INVALID_INVITE, { state: { invitationCode, hidePortfollio: true } });
      }
      if (errorMessage?.includes("INV-105")) {
        return appNavigate(ROUTE_PATH.INVITE_REQUIRED, { state: { hidePortfollio: true } });
      }

      Sentry.captureException(error, {
        tags  : { component: "useAccountInfo", endpoint: "getAccountInfo" },
        extra : { slug, errorMessage },
        level : "error",
      });
      toast.error(errorMessage);
    },
  });
};
